import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NodeApiService} from '../../network/online/node/node-api.service';
import {PeerConnectionApiService} from '../../peer-connection/peer-connection-api.service';
import {UrlQueryService} from '../../../common/url-query/url-query.service';
import {FileSaverService} from 'ngx-filesaver';

@Injectable({
  providedIn: 'root'
})
export class RegisteredUsersApiService {

  constructor(private http: HttpClient,
              private nodeService: NodeApiService,
              private pConService: PeerConnectionApiService,
              private fileSaverService: FileSaverService) {}

  readonly url: string = 'topology/registeredUsers';

  getRegisteredUsers(params): Promise<any> {
    params = UrlQueryService.restructureFilterParams(params);
    const url = UrlQueryService.addQueryParameters(this.url, params);
    return this.http.get(url).toPromise();
  }

  getExternalData(): Promise<any> {
    return Promise.all([this.nodeService.getNodes(), this.pConService.getPCons().then(pCons => pCons.elements)]);
  }

  public exportUsersToCsv(params): void {
    // restructureFilterParams(params);
    const url = UrlQueryService.addQueryParameters(`${this.url}/export`, params);

    this.http.get(url, { responseType: 'blob' }).subscribe(data => {
      const fileType = {type: 'text/csv'};
      const blob = new Blob([ data ], fileType);
      this.fileSaverService.save(blob, 'RegisteredUsers.csv');
    });
  }
}
